// Other NPM packages
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ClickOutsideModule } from 'ng-click-outside';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';

// Common
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { TimeHelper } from '../../Common/Forms/helpers/time.helper';
import { CommonDialogsModule } from '../../Common/Dialogs/common-dialogs.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { LayoutModule } from '../../Common/Layout/layout.module';
import { CommonBasicModule } from '../../Common/Basic/basic.module';
import { MentionsModule } from '../../Common/Mentions/mentions.module';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { TakeOverModule } from '../../Common/TakeOver/take-over.module';
import { ChartsModule } from '../../Common/Charts/charts.module';
import { ReportsModule } from '../../Common/Reports/reports.module';

import { MonitorSharedModule } from '../Shared/monitoring-shared.module';

// API
import { BriefingsApi } from '../../api/briefings/briefings.api';

// Page Builder
import { PageBuilderModule } from '../../Common/PageBuilder/page-builder.module';

// This module services
import { AlertsService } from './services/alerts.service';

// This module components
import { AlertComponent } from './components/Alert/alert.component';
import { AlertMentionListBlockComponent } from './components/AlertMentionListBlock/alert-mention-list-block.component';
import { AlertGlobalCustomizationComponent } from './components/AlertGlobalCustomization/alert-global-customization.component';
import { AlertMentionCustomizationFieldComponent } from './components/AlertMentionCustomizationField/alert-mention-customization-field.component';
import { AlertCreateDialogComponent } from './components/AlertCreateDialog/alert-create-dialog.component';
import { AlertSurgeSensitivityDialogComponent } from './components/AlertSurgeSensitivityDialog/alert-surge-sensitivity-dialog.component';
import { AlertDashboardComponent } from './components/AlertReportComponent/alert-dashboard.component';
import { AlertsSurgeChartService } from './services/alerts-surge-chart.service';
import { AlertLimitReachedDialogComponent } from './components/AlertLimitReachedDialog/alert-limit-reached.component';
import { AlertSeriesService } from './services/alert-series.service';
import { ReportsSeriesService } from '../../Common/Reports/services/reports-series.service';
import { SurgePeriodDateRangeFieldComponent } from './components/SurgePeriodDateRangeField/surge-period-date-range-field.component';
import { AdditionalSettingsFieldComponent } from './components/AdditionalSettingsField/additional-settings-field.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SelectModule,
        TooltipModule,
        PageBuilderModule,
        LocalizationModule,
        AutoCompleteModule,
        CommonFormsModule,
        CommonDialogsModule,
        ClickOutsideModule,
        MiscModule,
        MonitorSharedModule,
        LayoutModule,
        CommonBasicModule,
        MentionsModule,
        CoreDialogsModule,
        TakeOverModule,
        ChartsModule,
        ReportsModule
    ],
    declarations: [
        AlertComponent,
        AlertMentionListBlockComponent,
        AlertGlobalCustomizationComponent,
        AlertMentionCustomizationFieldComponent,
        AlertCreateDialogComponent,
        AlertSurgeSensitivityDialogComponent,
        AlertDashboardComponent,
        AlertLimitReachedDialogComponent,
        SurgePeriodDateRangeFieldComponent,
        AdditionalSettingsFieldComponent
    ],
    exports: [
        AlertComponent,
        AlertMentionListBlockComponent,
        AlertGlobalCustomizationComponent,
        AlertMentionCustomizationFieldComponent
    ],
    providers: [
        BriefingsApi,
        AlertsService,
        AlertsSurgeChartService,
        ReportsSeriesService,
        AlertSeriesService,
        {
            provide: 'AlertsService',
            useExisting: AlertsService
        },
        TimeHelper
    ]
})
export class AlertsModule { }
